import { useRef, useState } from 'react';
import { toast } from 'sonner';
import axiosInstance from '../libs/axiosInstance';
import { isAxiosError } from 'axios';

const QuestionFileUpload = ({
  onUploadSuccess,
  buttonText = "Upload Questions from File",
}) => {
  const fileInputRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const openModal = () => setIsOpen(true);
  const closeModal = () => {
    if (!isUploading) {
      setIsOpen(false);
      setSelectedFile(null);
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file || null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedFile) {
      toast.error('Please select a file to upload.');
      return;
    }
    setIsUploading(true);
    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const response = await axiosInstance.post(
        '/question_bank/questions/upload-csv/',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 60000,
        }
      );
      toast.success('Questions uploaded successfully!');
      toast.info("Upload Summary", {
        description: `Valid: ${response.data.valid_rows}, Invalid: ${response.data.invalid_rows} (Total: ${response.data.total_rows})`,
      });
      console.log('Upload response:', response.data);
      
      setIsOpen(false);
      setSelectedFile(null);
      if (fileInputRef.current) fileInputRef.current.value = '';
      if (onUploadSuccess) onUploadSuccess(response.data.data);
    } catch (error) {
      if(isAxiosError(error) && error.response) {
        const errorMessage = error.response.data?.message || 'An error occurred while uploading the file.';
        toast.error(errorMessage);
        return;
      }
      toast.error('Failed to upload questions');
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-accent"
        onClick={openModal}
        disabled={isUploading}
      >
        {buttonText}
      </button>
      <div className={`modal ${isOpen ? 'modal-open' : ''}`}>
        <div className="modal-box">
          <label className="absolute right-4 top-4">
            <button
              type="button"
              className="btn btn-sm btn-circle"
              onClick={closeModal}
              disabled={isUploading}
              aria-label="Close"
            >✕</button>
          </label>
          <h3 className="font-semibold text-lg mb-4">Upload Questions File</h3>
          <input
            type="file"
            accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,.json"
            ref={fileInputRef}
            onChange={handleFileChange}
            className="file-input file-input-bordered w-full"
            disabled={isUploading}
          />
          <div className="modal-action mt-6 flex gap-2">
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={isUploading || !selectedFile}
              type="button"
            >
              {isUploading ? 'Uploading...' : 'Upload'}
            </button>
            <button
              className="btn btn-ghost"
              onClick={closeModal}
              disabled={isUploading}
              type="button"
            >
              Cancel
            </button>
          </div>
          {isUploading && (
            <div className="mt-2 text-primary">Uploading...</div>
          )}
        </div>
        {isOpen && (
          <div className="modal-backdrop" onClick={closeModal}>
            <button className="">Close</button>
          </div>
        )}
      </div>
    </>
  );
};

export default QuestionFileUpload;